import { ReactElement } from 'react';

import classNames from 'classnames';

import { useIsDesktop } from '@vk-hr-tek/ui/hooks';
import { Box } from '@vk-hr-tek/ui/Box';

import { useIsWidget, useSelector } from '@app/hooks';
import { usePageProps } from '@app/context';

import { MobileMenu } from '../MobileMenu';
import { User } from '../../user';
import { selectUserRepresentative, usePermissions } from '../../../user';
import { BellNotifications } from '../../../bell-notifications/plugins';

import { SearchInput } from './SearchInput';
import { useStyles } from './Header.styles';

export const Header = () => {
  const isDesktop = useIsDesktop();
  const isWidget = useIsWidget();
  const { classes } = useStyles();
  const pageProps = usePageProps();
  const { view_quick_search: showSearch } = usePermissions('general');

  const userRepresentative = useSelector(selectUserRepresentative);

  const headerPaddingY = isDesktop ? '12' : '20';

  const headerPaddingCondition =
    window.REACT_APP_VKHRTEK_LK_DISABLED && !userRepresentative
      ? '20'
      : headerPaddingY;

  const justifyContentCondition =
    isDesktop || isWidget ? 'flex-end' : 'space-between';

  const bellComponent =
    pageProps && 'bellComponent' in pageProps
      ? pageProps.bellComponent
      : undefined;
  const userComponent =
    pageProps && 'userComponent' in pageProps
      ? pageProps.userComponent
      : undefined;

  return (
    <Box
      className={classNames(classes.header, isWidget && classes.widgetHeader)}
      py={headerPaddingCondition}
    >
      <Box
        justifyContent={justifyContentCondition}
        alignItems="center"
        display="flex"
        gap="16"
      >
        {!isDesktop && !isWidget && (
          <Box display="flex">
            <MobileMenu />
          </Box>
        )}

        {isDesktop && showSearch && <SearchInput />}

        {isDesktop &&
          (bellComponent
            ? (bellComponent as ReactElement)
            : !window.REACT_APP_VKHRTEK_HIDE_BELL && <BellNotifications />)}

        {userComponent ? (userComponent as ReactElement) : <User />}
      </Box>
    </Box>
  );
};
